/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_Futaroku_Tagline1Inputs */

const ja_home_brands_futaroku_tagline1 = /** @type {(inputs: Home_Brands_Futaroku_Tagline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームライフをもっと楽しくするための通販サイト`)
};

const en_home_brands_futaroku_tagline1 = /** @type {(inputs: Home_Brands_Futaroku_Tagline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAME CULTURE PRODUCTS THAT MEAN SOMETHING`)
};

/**
* | output |
* | --- |
* | "GAME CULTURE PRODUCTS THAT MEAN SOMETHING" |
*
* @param {Home_Brands_Futaroku_Tagline1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const home_brands_futaroku_tagline1 = /** @type {((inputs?: Home_Brands_Futaroku_Tagline1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_Futaroku_Tagline1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_futaroku_tagline1(inputs)
	return en_home_brands_futaroku_tagline1(inputs)
});
export { home_brands_futaroku_tagline1 as "home_brands_futaroku_tagLine" }